import axios from '@/http/index';

const base = '';

// 前台查看评价分析功能
export const getCommentAnalyseList = (id, params) => axios.get(`${base}/core/lookTechnicianScore/checkAssess?mainId=${id}`, params).then((res) => res.data);
